declare var Webcam:any;
declare var nccPath:any;
declare var form:string;

import { ModalControllerFr } from "./Controllers/ModalControllerFr";
import { FaceDetectionControllerFr } from "./Controllers/FaceDetectionControllerFr";
import { Selectors } from "./Selectors";

export class PublicFr {
    modalController: ModalControllerFr;
    faceDetectionController: FaceDetectionControllerFr;

    constructor() {
        const webcamElement = (<HTMLVideoElement> document.getElementById(Selectors.videoElementId));
        const canvasElement = (<HTMLCanvasElement>document.getElementById(Selectors.canvasElementId));
        const canvasSecondElement = (<HTMLCanvasElement>document.getElementById(Selectors.canvasSecondElementId));
        const webcam = new Webcam(webcamElement, 'user', canvasElement);

        this.modalController = new ModalControllerFr(webcam);
        this.faceDetectionController = new FaceDetectionControllerFr(webcamElement, canvasSecondElement, webcam, false, false, false, false, false, nccPath, form);
    }

    public init() {
        this.modalController.init(this.faceDetectionController);
        this.faceDetectionController.init();
    }
}

